<template>
    <!-- Sidebar -->
    <div id="sidebar-wrapper">
        <ul class="sidebar-nav nav-pills nav-stacked" id="menu">
            <template v-for="(menuData, index) in $store.getters.menuArr">
                <li v-bind:key="index" :id="menuData.slug" :class="'menuCommon '+menuData.slug">
                    <template v-if="menuData.is_view_allow == 1">
                        <template v-if="menuData.sub_menu == '' || menuData.sub_menu == null">
                            <template v-if="menuData.url != null && menuData.url != '' && menuData.is_view_allow == 1">
                                <template v-if="menuData.menu_title.length >= 22">
                                    <a :href="menuData.url" target="_blank" v-b-tooltip.hover :title="menuData.menu_title">
                                        <span :class="'spm-nav-menu ' + menuData.icon_url">    
                                        </span>
                                        {{stringTrim(menuData.menu_title,22)}}
                                    </a>
                                </template>
                                <template v-else>
                                    <a :href="menuData.url" target="_blank">
                                        <span :class="'spm-nav-menu ' + menuData.icon_url">    
                                        </span>
                                        {{menuData.menu_title}}
                                    </a>
                                </template>
                            </template>
                            <template v-else>
                                <template v-if="menuData.menu_title.length >= 22">
                                    <router-link v-b-tooltip.hover :title="menuData.menu_title" v-bind:to="{name: 'CommonPage', params:{type:menuData.slug}}">
                                        <span :class="'spm-nav-menu ' + menuData.icon_url">
                                        </span>{{stringTrim(menuData.menu_title,22)}}
                                    </router-link>
                                </template>
                                <template v-else>
                                    <router-link v-bind:to="{name: 'CommonPage', params:{type:menuData.slug}}">
                                        <span :class="'spm-nav-menu ' + menuData.icon_url">
                                        </span>{{menuData.menu_title}}
                                    </router-link>
                                </template>
                            </template>
                        </template>
                        <template v-else>
                            <template v-if="menuData.url != null && menuData.url != ''">
                                <template v-if="menuData.menu_title.length >= 22">
                                    <a v-b-tooltip.hover :title="menuData.menu_title" :href="menuData.url" target="_blank">
                                        <label class="tree-toggle nav-header">
                                            <span :class="'spm-nav-menu ' + menuData.icon_url">
                                            </span> {{stringTrim(menuData.menu_title,22)}}
                                            <i class="fa fa-angle-down" aria-hidden="true"></i>
                                        </label>
                                    </a>
                                </template>
                                <template v-else>
                                    <a :href="menuData.url" target="_blank">
                                        <label class="tree-toggle nav-header">
                                            <span :class="'spm-nav-menu ' + menuData.icon_url">
                                            </span> {{menuData.menu_title}}
                                            <i class="fa fa-angle-down" aria-hidden="true"></i>
                                        </label>
                                    </a>
                                </template>
                            </template>
                            <template v-else>
                                <template v-if="menuData.menu_title.length >= 22">
                                    <router-link v-b-tooltip.hover :title="menuData.menu_title" v-bind:to="{name: 'CommonPage', params:{type:menuData.slug}}">
                                        <label class="tree-toggle nav-header">
                                            <span :class="'spm-nav-menu ' + menuData.icon_url">
                                            </span> {{stringTrim(menuData.menu_title,22)}}
                                            <i class="fa fa-angle-down" aria-hidden="true"></i>
                                        </label>
                                    </router-link>
                                </template>
                                <template v-else>
                                    <router-link v-bind:to="{name: 'CommonPage', params:{type:menuData.slug}}">
                                        <label class="tree-toggle nav-header">
                                            <span :class="'spm-nav-menu ' + menuData.icon_url">
                                            </span> {{menuData.menu_title}}
                                            <i class="fa fa-angle-down" aria-hidden="true"></i>
                                        </label>
                                    </router-link>
                                </template>
                            </template>
                            <ul class="nav nav-list tree">
                                <template v-for="(subMenuData, index1) in menuData.sub_menu">
                                    <template v-if="subMenuData.url != null && subMenuData.url != ''">
                                        <li :key="index1" :class="'subMenuLi '+subMenuData.slug">
                                            <template v-if="subMenuData.menu_title.length >= 30">
                                                <a v-b-tooltip.hover :title="subMenuData.menu_title" :href="subMenuData.url" target="_blank">
                                                    {{stringTrim(subMenuData.menu_title,30)}}
                                                </a>
                                            </template>
                                            <template v-else>
                                                <a :href="subMenuData.url" target="_blank">
                                                    {{subMenuData.menu_title}}
                                                </a>
                                            </template>
                                        </li>
                                    </template>
                                    <template v-else>
                                        <li :key="index1" :class="'subMenuLi '+subMenuData.slug">
                                            <template v-if="subMenuData.menu_title.length >= 30">
                                                <router-link v-b-tooltip.hover :title="subMenuData.menu_title" v-bind:to="{name: 'CommonPage', params:{type:subMenuData.slug}}">
                                                    {{stringTrim(subMenuData.menu_title,30)}}
                                                </router-link>
                                            </template>
                                            <template v-else>
                                                <router-link v-bind:to="{name: 'CommonPage', params:{type:subMenuData.slug}}">
                                                    {{subMenuData.menu_title}}
                                                </router-link>
                                            </template>
                                        </li>
                                    </template>
                                </template>
                            </ul>
                        </template>
                    </template>
                </li>
            </template>
            <li>
                <ul class="nav nav-list tree">
                    <template v-if="loginUsername == 9999999">
                        <li id="ListFormEmailManager">
                            <router-link v-bind:to="{name: 'ListFormEmailManager'}">
                                Form Email Manager
                            </router-link>
                        </li>
                    </template>
                </ul>
            </li>
        </ul>
    </div>
<!-- Sidebar -->
</template>

<script>
    import Vue from 'vue';
    import {HTTP} from '../../http-common.js';
    import EventBus from '.././event-bus';
    var self;

    import {commonMixins} from '../../mixins/commonMixins';

    export default {
        name: 'Sidebar',
        mixins: [commonMixins],
        data() {
            return {
                menuArr: [],
                loginUserRoleId: 1,
                loginUsername: 9999999
            }
        },
        beforeMount: function () {
        },
        mounted: function () {
            self = this;
            $("#menu-toggle").click(function (e) {
                e.preventDefault();
                $(".app-sidebar-right").toggleClass("toggled");
            });
            $("#menu-toggle-2").click(function (e) {
                e.preventDefault();
                $(".app-sidebar-right").toggleClass("toggled-2");
                $('#menu ul').hide();
            });

            $('.tree-toggle').click(function () {
                $(this).parent().children('ul.tree').toggle(200);
            });

            var userObj = localStorage.getItem('user_obj');
            if (userObj && userObj != null) {
                var userJson = JSON.parse(userObj);
                self.loginUserRoleId = userJson['role'].system_id;
                self.loginUsername = userJson['username'];
                self.$store.dispatch('loadMenu');
            }
        },
        methods: {
        }
    };
    EventBus.$on('reload-menu', function (menuArr) {
        if (typeof (self) != 'undefined') {
            self.$nextTick(() => {
                self.firstLoadMenu();
            });
        }
    });
</script>


// WEBPACK FOOTER //
// src/components/partials/Sidebar.vue